"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uploadProductImages = exports.updateProductVariations = exports.updateProductInventories = exports.updateProductImages = exports.updateProductCategories = exports.updateProductAttributes = exports.updateProduct = exports.searchProducts = exports.productCount = exports.importProduct = exports.getVariations = exports.getVariationById = exports.getProducts = exports.getProductById = exports.deleteProductVariation = exports.deleteProductImages = exports.deleteProduct = exports.defaultProductData = exports.createProduct = exports.addNewProductsImages = exports.addNewProductImage = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
const defaultProductData = exports.defaultProductData = {
  id: 0,
  enabled: true,
  name: null,
  productType: 'variable',
  priority: null,
  multiplier: 1,
  featured: false,
  isGiftItem: false,
  isIsi: false,
  isfreightAllowed: true,
  catalogueCode: undefined,
  suppliedBy: '',
  tags: null,
  technicalDescription: null,
  description: null,
  isTaxable: true,
  taxId: 5,
  hsnCode: null,
  videoUrl: null,
  manageStock: false,
  stockStatus: 'In Stock',
  tax: {
    id: 5
  },
  category: [],
  categoryId: null,
  attribute: [],
  productsImage: [],
  productsVariation: [],
  categorization: '',
  productsField: [],
  brandId: undefined,
  brand: {
    id: undefined
  },
  slug: null,
  sampleType: 'Non Consumable',
  isSampleAvailable: false,
  externalCategory: [],
  relatedProduct: [],
  isNew: false,
  isVisibleOnWeb: true,
  drawingFile: null,
  licenseFile: null
};
const getProducts = params => (0, _request.default)({
  url: '/products',
  method: 'get',
  params
});
exports.getProducts = getProducts;
const getProductById = (id, params = null) => (0, _request.default)({
  url: `/products/${id}`,
  method: 'get',
  params
});
exports.getProductById = getProductById;
const updateProduct = (id, data) => (0, _request.default)({
  url: `/products/${id}`,
  method: 'patch',
  data
});
exports.updateProduct = updateProduct;
const deleteProduct = id => (0, _request.default)({
  url: `/products/${id}`,
  method: 'delete'
});
exports.deleteProduct = deleteProduct;
const createProduct = data => (0, _request.default)({
  url: '/products/',
  method: 'post',
  data
});
exports.createProduct = createProduct;
const productCount = params => (0, _request.default)({
  url: '/products/count',
  method: 'get',
  params
});
exports.productCount = productCount;
const updateProductCategories = (id, data) => (0, _request.default)({
  url: `/products/categories/${id}`,
  method: 'patch',
  data
});
exports.updateProductCategories = updateProductCategories;
const updateProductAttributes = (id, data) => (0, _request.default)({
  url: `/products/attributes/${id}`,
  method: 'patch',
  data
});
exports.updateProductAttributes = updateProductAttributes;
const searchProducts = params => (0, _request.default)({
  url: '/products/search',
  method: 'get',
  params
});
exports.searchProducts = searchProducts;
const getVariations = params => (0, _request.default)({
  url: '/products-variations',
  method: 'get',
  params
});
exports.getVariations = getVariations;
const getVariationById = id => (0, _request.default)({
  url: `/products-variations/${id}`,
  method: 'get'
});
exports.getVariationById = getVariationById;
const updateProductVariations = data => (0, _request.default)({
  url: '/products-variations/manage',
  method: 'post',
  data
});
exports.updateProductVariations = updateProductVariations;
const deleteProductVariation = id => (0, _request.default)({
  url: `/products-variations/${id}`,
  method: 'delete'
});
exports.deleteProductVariation = deleteProductVariation;
const updateProductImages = (id, data) => (0, _request.default)({
  url: `/products/images/${id}`,
  method: 'patch',
  data
});
exports.updateProductImages = updateProductImages;
const deleteProductImages = id => (0, _request.default)({
  url: `/products-images/${id}`,
  method: 'delete'
});
exports.deleteProductImages = deleteProductImages;
const updateProductInventories = (id, data) => (0, _request.default)({
  url: `/products/inventories/${id}`,
  method: 'patch',
  data
});
exports.updateProductInventories = updateProductInventories;
const uploadProductImages = data => (0, _request.default)({
  url: '/products/images',
  method: 'post',
  data
});
exports.uploadProductImages = uploadProductImages;
const importProduct = data => (0, _request.default)({
  url: '/products/file-import',
  method: 'post',
  data
});
exports.importProduct = importProduct;
const addNewProductsImages = data => (0, _request.default)({
  url: '/products-images',
  method: 'post',
  data
});
exports.addNewProductsImages = addNewProductsImages;
const addNewProductImage = data => (0, _request.default)({
  url: '/products-images/upload',
  method: 'post',
  data
});
exports.addNewProductImage = addNewProductImage;